// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"434":"92bbc559","544":"92bbc559","757":"92bbc559","965":"92bbc559"}[chunkId] + ".chunk.css";
};